export default __webpack_public_path__ + "static/nr-b1bb61f39f76a72eaaa3c28c9881ee00.svg";